/** Bounded optional metadata shared by browser codecs and the durable writer. */
export type FitnessSetType = 'warmup' | 'working';
export type FitnessGroupType = 'superset' | 'circuit';
export interface FitnessExerciseMetadata { notes?: string; groupId?: string; groupType?: FitnessGroupType }
export interface FitnessSetMetadata { type?: FitnessSetType; rir?: number }
export const FITNESS_EXERCISE_METADATA_FIELDS = ['notes', 'groupId', 'groupType'] as const;
export const FITNESS_SET_METADATA_FIELDS = ['type', 'rir'] as const;
const own = (value: object, key: string) => Object.prototype.hasOwnProperty.call(value, key);
export function validFitnessExerciseMetadata(value: Record<string, unknown>): boolean {
  return (!own(value, 'notes') || typeof value.notes === 'string' && value.notes.length <= 2000 && !value.notes.includes('\u0000'))
    && (!own(value, 'groupId') || typeof value.groupId === 'string' && /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(value.groupId))
    && (!own(value, 'groupType') || own(value, 'groupId') && (value.groupType === 'superset' || value.groupType === 'circuit'));
}
export function validFitnessSetMetadata(value: Record<string, unknown>): boolean {
  return (!own(value, 'type') || value.type === 'warmup' || value.type === 'working')
    && (!own(value, 'rir') || typeof value.rir === 'number' && Number.isSafeInteger(value.rir) && value.rir >= 0 && value.rir <= 10);
}
export function copyFitnessExerciseMetadata(value: Record<string, unknown>): FitnessExerciseMetadata {
  if (!validFitnessExerciseMetadata(value)) throw new Error('invalid_fitness_exercise_metadata');
  return { ...(own(value, 'notes') ? { notes: value.notes as string } : {}),
    ...(own(value, 'groupId') ? { groupId: value.groupId as string } : {}),
    ...(own(value, 'groupType') ? { groupType: value.groupType as FitnessGroupType } : {}) };
}
export function copyFitnessSetMetadata(value: Record<string, unknown>): FitnessSetMetadata {
  if (!validFitnessSetMetadata(value)) throw new Error('invalid_fitness_set_metadata');
  return { ...(own(value, 'type') ? { type: value.type as FitnessSetType } : {}),
    ...(own(value, 'rir') ? { rir: value.rir as number } : {}) };
}
